var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSignGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.82 8.4118V8.41317V19.5865C26.82 21.9137 26.1282 23.7112 24.9131 24.9263C23.698 26.1414 21.9006 26.8332 19.5733 26.8332H8.41332C6.0861 26.8332 4.28883 26.1414 3.07376 24.9248C1.85863 23.7082 1.16666 21.9074 1.16666 19.5732V8.41317C1.16666 6.08594 1.85842 4.28852 3.07354 3.07339C4.28867 1.85827 6.08609 1.1665 8.41332 1.1665H19.5867C21.914 1.1665 23.7112 1.85831 24.9245 3.07317C26.1378 4.28793 26.8264 6.08488 26.82 8.4118ZM15.5 19.3332V15.4998H19.3333C20.1561 15.4998 20.8333 14.8226 20.8333 13.9998C20.8333 13.177 20.1561 12.4998 19.3333 12.4998H15.5V8.6665C15.5 7.84369 14.8228 7.1665 14 7.1665C13.1772 7.1665 12.5 7.8437 12.5 8.6665V12.4998H8.66666C7.84385 12.4998 7.16666 13.177 7.16666 13.9998C7.16666 14.8226 7.84385 15.4998 8.66666 15.4998H12.5V19.3332C12.5 20.156 13.1772 20.8332 14 20.8332C14.8228 20.8332 15.5 20.156 15.5 19.3332Z",
    fill: "url(#paint0_linear_667_2663)",
    stroke: "url(#paint1_linear_667_2663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_667_2663",
    x1: 8.68432,
    y1: 5.42673,
    x2: 18.5459,
    y2: 23.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_667_2663",
    x1: 8.68432,
    y1: 5.42673,
    x2: 18.5459,
    y2: 23.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSignGray);
export default __webpack_public_path__ + "static/media/add-sign-gray.6726d38198202a006fdbef78c41053bf.svg";
export { ForwardRef as ReactComponent };